export function publishedArticleUrl(value?: string): string | undefined {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || !['freiheitsfunken.info', 'www.freiheitsfunken.info', 'ef-magazin.de', 'www.ef-magazin.de'].includes(url.hostname)
        || url.username || url.password || url.port || url.search || url.hash
        || !/^\/(?:a\/\d+\/?|\d{4}\/\d{2}\/\d{2}\/\d+-[^/]+\/?)$/.test(url.pathname)) return undefined;
    return url.href;
  } catch { return undefined; }
}
